module.exports = __webpack_public_path__ + "media/images/padlet_logo_white-fee5f8303f79ffe1a3415464653192e0.svg";